export default __webpack_public_path__ + "static/media/bottle.d8477e8e.svg";